export default "__VITE_ASSET__404ff9b0__"